import * as Yup from 'yup'
import { REGEXS } from 'utils'

const amountValidation = REGEXS.amountRegex
const zipCodeRegex = REGEXS.zipcodeRegex

const schema = Yup.object().shape({
  Title: Yup.string().required('Title is required'),
  Description: Yup.string()
    .required('Description is required')
    .min(10, 'Description should be atleast 10 character'),
  Requirements: Yup.string(),
  // .required('Requirements is required')
  // .min(10, 'Requirements should be atleast 10 character'),
  ProgramFees: Yup.string()
    .required('Service Dues is required')
    .matches(amountValidation, 'Invalid cost'),
  DeliveryLocation: Yup.string().required('Delivery Location is required'),
  ZipCode: Yup.string()
    .matches(zipCodeRegex, 'Invalid Zip code e.g 12345')
    .required('Zip Code is required'),
  City: Yup.string().required('City is required'),
  LocationState: Yup.string().required('State is required'),
  Address: Yup.string().required('Address is required'),
  NoteHeading: Yup.string()
    .required('NoteHeading is required')
    .min(10, 'NoteHeading should be atleast 10 character'),
  NoteDescription: Yup.string()
    .required('NoteDescription is required')
    .min(10, 'NoteDescription should be atleast 10 character'),
  ServiceType: Yup.string().required('Service Template is required'),
  IncludeProcessingFee: Yup.boolean().required(
    'Include processing fee is required',
  ),
  AllowRecurringPayments: Yup.boolean().required(
    'Allow recurring payments is required',
  ),
  NumberOfDefaultRecurring: Yup.string().required(
    'Duration of recurring payment is required',
  ),
  PaymentCategoryAdded: Yup.string().required(
    'Payment category added is required',
  ),
  Flyer: Yup.mixed().typeError('Flyer is not a file'),
  ShowOnLandingPage: Yup.string().required('Show on landing page is required'),
  RequestedTimeHelpText: Yup.string(),
  CeremonyLocationHelpText: Yup.string(),
  BrideReligionHelpText: Yup.string(),
  GroomReligionHelpText: Yup.string(),
  NumberOfAttendeesHelpText: Yup.string(),
})

const serviceValidation = {
  async validator({ field }, value) {
    await schema.validateSyncAt(field, { [field]: value })
  },
}

export { serviceValidation }
